/* B2B collection swatch tooltip; theme.js retains all variant image switching. */
(function(){
  var selector='.tjb2b-redesigned-card .tjb2b-native-variant-swatches .tjb2b-native-swatch';
  document.addEventListener('click',function(event){
    var clicked=event.target.closest(selector);
    document.querySelectorAll(selector+'.tjb2b-show-tip').forEach(function(el){
      if(el!==clicked)el.classList.remove('tjb2b-show-tip');
    });
    if(clicked)clicked.classList.add('tjb2b-show-tip');
  },true);
  document.addEventListener('keydown',function(event){
    var target=event.target;
    if(!target.matches || !target.matches(selector))return;
    if(event.key==='Enter' || event.key===' '){event.preventDefault();target.click();}
  },true);
})();
